// extracted by mini-css-extract-plugin
export default {"scrollable-container":"components-parity-parity-manager-attachment-form-module__scrollable-container"};